import {
  Alert,
  CreateModal,
  RoundedTab,
  RoundedTabGroup,
} from "@mikros/shared-ui";
import React, { useEffect, useRef, useState } from "react";
import { Button } from "@progress/kendo-react-buttons";
import {
  CohortModel,
  CohortModelResource,
  CohortUser,
  FetchAllUsers,
  FetchCohorts,
} from "@mikros/library";
import { CohortDisplay } from "./cohortCreation/cohortDisplay";
import ApiServices from "../../service/apiService";
import { CreateUser } from "./userCreation/createUser";
import { CreateStaticList } from "./cohortCreation/createStaticList";
import { FormattedMessage, useIntl } from "react-intl";
import { Upload } from "@progress/kendo-react-upload";
import { Dialog } from "@progress/kendo-react-dialogs";
import { ComponentDialog } from "@mikros/shared-ui";
import { UploadFile } from "./uploadFile";
import Account from "../../utils/apiConfig";
import ErrorHandler from "../../utils/errorConfig";
import { useNavigate } from "react-router-dom";
import {
  InputClearValue,
  TextBox,
  TextBoxChangeEvent,
} from "@progress/kendo-react-inputs";
import { Icon } from "@progress/kendo-react-common";
import { SearchUserDup } from "./userCreation/searchUserDup";
import { SearchFilterUser } from "./userCreation/searchFilterUser";
import { TextBoxCreationDup } from "./cohortCreation/textBoxCreationDup";
import { CohortListDup } from "./cohortUsers/cohortListDup";

export interface UserPageProps {}
export function UserPageDup(props: UserPageProps) {
  const allValue = "All";
  const EMPTY_VALUE = "";
  const intl = useIntl();
  const accountInstance = Account.getInstance();
  const errorInstance = ErrorHandler.getErrorInstance();
  const navigate = useNavigate();
  // const filterOptions = [
  //   { value: "active", label: intl.formatMessage({ id: "activeTrainees" }) },
  //   {
  //     value: "inactive",
  //     label: intl.formatMessage({ id: "inactiveTrainees" }),
  //   },
  //   { value: "all", label: intl.formatMessage({ id: "allTrainees" }) },
  // ];

  const [cohorts, setCohorts] = useState<CohortModelResource>({
    resources: [{} as CohortModel],
  } as CohortModelResource);
  const [currCohort, setCurrCohort] = useState<any>();
  const [fetchCohorts, setFetchChorts] = useState<FetchCohorts>({
    cohortUsers: [{} as CohortUser],
  } as FetchCohorts);
  const [showCreateUser, setCreateUser] = useState(false);
  const [showSearchUser, setSearchUser] = useState(true);
  const [showCreateCohort, setShowCreateCohort] = useState(true);
  const [uploadContent, setUploadContent] = useState<boolean>(false);
  const [showAddNewUser, setShowAddNewUser] = useState(false);
  const [showCohorts, setShowCohorts] = useState(true);
  const [showDialog, setDialog] = useState(false);
  const [uploadDialog, setUploadDialog] = React.useState<boolean>(false);
  const [searchValue, setSearchValue] = useState<string>("");
  const refreshData = useRef(true); // Move to parent
  // const hasMoreData = useRef(true);
  const [hasMoreData, setHasMoreData] = useState(true); // Track if more data is available

  const languages = ["English", "Hindi", "Tamil", "is empty"];
  // const allValue = "All";
  const [selectedStatus, setSelectedStatus] = useState("active");
  const [selectedLanguage, setSelectedLanguage] = useState<string[]>([
    ...languages,
  ]);
  const [errors, setErrors] = useState<any>();

  const updateData = useRef(true);

  console.log("print has more data ref in users dup", refreshData);

  //props to user data
  const [fetchAllUser, setFetchAllUser] = useState<boolean>(false);
  const [userFetchModel, setUserFetchModel] = useState<FetchAllUsers>({
    users: [],
    lastKey: "",
  });
  const [totalUserCount, setTotalUserCount] = useState<number>(0);
  const [searchActive, setSearchActive] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    branchName: "",
    department: "",
    location: "",
    designation: "",
    email: "",
    phNo: "",
  });

  console.log("search value in cohort name", searchValue);
  //error
  const [errorCodeFlag, setErrorCodeFlag] = useState<boolean>(false);

  const desgOrDept = intl.formatMessage({
    id: "users.modal.options.department",
  });
  const langOrAge = intl.formatMessage({ id: "users.modal.options.langOrAge" });
  const locOrBranch = intl.formatMessage({
    id: "users.modal.options.locOrBranch",
  });
  const genderOrDoj = intl.formatMessage({
    id: "users.modal.options.genderOrDoj",
  });
  const createCohortByYourself = intl.formatMessage({
    id: "users.modal.options.createCohortByYourself",
  });
  const staticList = intl.formatMessage({
    id: "users.modal.options.staticList",
  });

  const [screenState, setScreenState] = useState<string>(
    intl.formatMessage({ id: "users.modal.defaultCase" })
  );
  const [showCohortList, setShowCohortList] = useState(false);

  var [gridData, setGridData] = useState<any>();
  const [formType, setFormType] = useState<boolean>(false);

  //error
  const [errorFlag, setErrorFlag] = useState<boolean>(false);

  const handleItemClick = (lang: string) => {
    let updatedSelection = [...selectedLanguage];
    if (lang === allValue) {
      updatedSelection = [...languages];
    } else {
      if (updatedSelection.includes(lang)) {
        updatedSelection = updatedSelection.filter((l) => l != lang);
      } else {
        updatedSelection.push(lang); //check
      }
    }
    if (updatedSelection.length === languages.length) {
      updatedSelection = [...languages];
    }
    // setSelectedLanguage(updatedSelection);
    setSelectedLanguage(updatedSelection);
  };

  const handleClearAll = () => {
    const hasValues = Object.values(formData).some((value) => value !== "");

    if (!hasValues) {
      console.log("No values to clear. Exiting handleClearAll.");
      return; //  Skip API call if all fields are empty
    }
    setFormData({
      designation: "", // Reset all fields to empty or their default value
      firstName: "",
      branchName: "",
      location: "",
      department: "",
      email: "",
      phNo: "",
    });
    setErrors({});

    let api = ApiServices.getInstance();
    if (accountInstance.accntId) {
      api
        .makeRequest(
          // `${accountInstance.accntId}/user/filter`,
          `${accountInstance.accntId}/user?limit=20`,
          "GET"
        )
        .then(async (data) => {
          if (data && data.errorMessage) {
            console.log("I entered error code handling in users");
            setErrorFlag(true);
            await errorInstance.updateErrorCode(data.errorMessage);
            return;
          } else {
            setUserFetchModel(data);
            setTotalUserCount(data.users.length);
            setSearchActive(false);
          }
        });
      // setSearchClicked(false); // Reset the search click status
    }
  };

  const handleClear = () => {
    setSearchValue(EMPTY_VALUE);
  };
  const handleSearchValueChange = (e: TextBoxChangeEvent) => {
    setSearchValue(e.value?.toString()!!);
  };

  const handleClick = (cohort: CohortModel) => {
    setShowCohortList(true);
    console.log("cohort data", cohort);
    setCurrCohort(cohort);
    setShowCohorts(false);
  };

  const toggleUploadDialog = () => {
    setUploadDialog(!uploadDialog);
  };

  console.log("search user state", showSearchUser);
  console.log("grid items in users", gridData);

  const data = [
    {
      icon: "department.png",
      iconDescription: `${intl.formatMessage({
        id: "users.modal.options.department",
      })}`,
    },
    {
      icon: "langOrAge.png",
      iconDescription: `${intl.formatMessage({
        id: "users.modal.options.langOrAge",
      })}`,
    },
    {
      icon: "genderOrDoj.png",
      iconDescription: `${intl.formatMessage({
        id: "users.modal.options.genderOrDoj",
      })}`,
    },
    {
      icon: "locOrBranch.png",
      iconDescription: `${intl.formatMessage({
        id: "users.modal.options.locOrBranch",
      })}`,
    },
    {
      icon: "createACohort.png",
      iconDescription: `${intl.formatMessage({
        id: "users.modal.options.createCohortByYourself",
      })}`,
    },
    {
      icon: "staticList.png",
      iconDescription: `${intl.formatMessage({
        id: "users.modal.options.staticList",
      })}`,
    },
  ];
  const goToUserCohorts = (e: string) => {
    console.log("print screen state", e);
    setScreenState(e);
    setDialog(false);
    setShowCohorts(false);
  };

  // const handleCreateCohortClick = () => {
  //   setDialog(true);
  // };

  const handleCreateCohortClick = () => {
    // setDialog(true);
    goToUserCohorts(createCohortByYourself);
  };
  const handleCreateUserClick = () => {
    setCreateUser(true);
    setSearchUser(false);
    setFormType(false);
    // setFormData({
    //   designation: "", // Reset all fields to empty or their default value
    //   firstName: "",
    //   branchName: "",
    //   location: "",
    //   department: "",
    //   email: "",
    //   phNo: "",
    // });
    handleClearAll();
    setSelectedStatus("active");
    handleItemClick(allValue);
  };

  console.log("form type in users", formType);

  function getCohorts() {
    let api = ApiServices.getInstance();
    if (accountInstance.accntId) {
      api
        .makeRequest(`${accountInstance.accntId}/cohort`, "GET")
        .then(async (data) => {
          if (data && data.errorMessage) {
            setErrorFlag(true);
            await errorInstance.updateErrorCode(data.errorMessage);
            return;
          }

          setCohorts(data);
          console.log("Cohort ids", data);
        });
    }
  }

  async function getCohortUsers(cohortId: string): Promise<FetchCohorts> {
    console.log("Hi, i am");
    let x: FetchCohorts = {} as FetchCohorts;

    let api = ApiServices.getInstance();
    if (accountInstance.accntId) {
      x = await api
        .makeRequest(`${accountInstance.accntId}/cohort/${cohortId}`, "GET")
        .then(async (res) => {
          if (res && res.errorMessage) {
            setErrorFlag(true);
            await errorInstance.updateErrorCode(res.errorMessage);
            return;
          }

          console.log("s res", res);

          setFetchChorts(res);
          console.log("Get response", res);
          return res;
        });
    }

    console.log("this is fetchcohorts", x);
    return x as FetchCohorts;
  }
  var flag = 0;
  const handleGridItemClick = (data: any) => {
    setGridData(data);
    console.log("rec data in parent", data);
    flag = 1;
  };

  function resetTabs(tabName: string) {
    setCreateUser(false);
    setSearchUser(true);
    setShowCohorts(true);
    setScreenState(intl.formatMessage({ id: "users.modal.defaultCase" }));
    setShowCohortList(false);
    if (tabName === "cohort") {
      getCohorts();
    }
    setFormType(false);
    setSelectedStatus("active");
    handleItemClick(allValue);
    if (tabName == "cohort") {
      setFormData({
        firstName: "",
        branchName: "",
        department: "",
        location: "",
        designation: "",
        email: "",
        phNo: "",
      });
    }
  }

  useEffect(() => {
    async function initializeAndUseAccount() {
      await accountInstance.fetchAccountId();
      console.log(
        "account id instance in tenant side",
        accountInstance.accntId
      );
      getCohorts();
    }

    initializeAndUseAccount();
  }, []);

  return (
    <div className="flex">
      <div className="w-full">
        <RoundedTabGroup defaultTabName="cohort" onClick={resetTabs}>
          <RoundedTab
            name="cohort"
            title={intl.formatMessage({
              id: "users.tabName.userCohorts",
            })}
          >
            {errorFlag && (
              <Dialog className="errorDialogue">
                <Alert
                  description={intl.formatMessage({
                    id: errorInstance.errorCode,
                  })}
                  buttonText={`${intl.formatMessage({
                    id: "users.buttonText.Ok",
                  })}`}
                  icon={"errorShape.png"}
                  iconMsg={intl.formatMessage({
                    id: "iconMsgError",
                  })}
                  backgroundColor={"mk-red"}
                  onClick={() => {
                    setErrorFlag(false);
                    if (errorInstance.permDenied === true) {
                      navigate("/home");
                    } else {
                      navigate("/users");
                    }
                  }}
                />
              </Dialog>
            )}
            {showCreateCohort &&
              (() => {
                switch (screenState) {
                  case desgOrDept:
                    return (
                      // <TextBoxCreation
                      <TextBoxCreationDup
                        state={screenState}
                        cohortLandState={setShowCohorts}
                        refreshedCohorts={() => {
                          getCohorts();
                        }}
                        newCohortState={() => {
                          resetTabs(
                            intl.formatMessage({
                              id: "users.tabName.userCohorts",
                            })
                          );
                        }}
                      />
                    );
                  case langOrAge:
                    return (
                      // <TextBoxCreation
                      <TextBoxCreationDup
                        state={screenState}
                        cohortLandState={setShowCohorts}
                        refreshedCohorts={() => {
                          getCohorts();
                        }}
                        newCohortState={() => {
                          resetTabs(
                            intl.formatMessage({
                              id: "users.tabName.userCohorts",
                            })
                          );
                        }}
                      />
                    );
                  case genderOrDoj:
                    return (
                      // <TextBoxCreation
                      <TextBoxCreationDup
                        state={screenState}
                        cohortLandState={setShowCohorts}
                        refreshedCohorts={() => {
                          getCohorts();
                        }}
                        newCohortState={() => {
                          resetTabs(
                            intl.formatMessage({
                              id: "users.tabName.userCohorts",
                            })
                          );
                        }}
                      />
                    );
                  case locOrBranch:
                    return (
                      // <TextBoxCreation
                      <TextBoxCreationDup
                        state={screenState}
                        cohortLandState={setShowCohorts}
                        refreshedCohorts={() => {
                          getCohorts();
                        }}
                        newCohortState={() => {
                          resetTabs(
                            intl.formatMessage({
                              id: "users.tabName.userCohorts",
                            })
                          );
                        }}
                      />
                    );
                  case createCohortByYourself:
                    return (
                      // <TextBoxCreation
                      <TextBoxCreationDup
                        state={screenState}
                        cohortLandState={setShowCohorts}
                        refreshedCohorts={() => {
                          getCohorts();
                        }}
                        newCohortState={() => {
                          resetTabs(
                            intl.formatMessage({
                              id: "users.tabName.userCohorts",
                            })
                          );
                        }}
                      />
                    );
                  case staticList:
                    return <CreateStaticList />;
                }
              })()}

            <div className="container">
              {/* <div className="w-full flex justify-start pl-56 items-center mt-[-2.25rem]"> */}
              <div className="w-full flex justify-start pl-64 items-center mt-[-2.25rem]">
                {showCohorts && (
                  <TextBox
                    value={searchValue}
                    onChange={handleSearchValueChange}
                    placeholder={`${intl.formatMessage({
                      id: "user.cohortNamePlaceholderText",
                    })}`}
                    suffix={() => (
                      <>
                        {searchValue !== EMPTY_VALUE && (
                          <InputClearValue onClick={handleClear}>
                            <Icon name="x"></Icon>
                          </InputClearValue>
                        )}
                      </>
                    )}
                    className={`w-[20%] rounded-l border border-mk-primary h-10`}
                  />
                )}
              </div>
              <div className="w-full flex justify-end items-center mt-[-2.25rem] right-12 top-20">
                <div className="pr-10"></div>
                {showCohorts && (
                  <Button
                    className="rounded-lg bg-mk-primary-bright text-white hover:bg-mk-light-grey
                                 hover:text-black focus:outline-none px-4 py-2"
                    onClick={handleCreateCohortClick}
                  >
                    <FormattedMessage id="users.createCohort" />
                  </Button>
                )}
              </div>
              {showDialog && showCohorts && (
                <CreateModal
                  description={intl.formatMessage({
                    id: "users.modal.description",
                  })}
                  successText={intl.formatMessage({
                    id: "users.modal.successText",
                  })}
                  onCancel={() => setDialog(false)}
                  onSuccess={(e: string) => goToUserCohorts(e)}
                  data={data}
                />
              )}
              <div className="mb-6"></div>
              {/* {showCohorts && (
                  <div className="mb-4 w-full pb-[10%] pl-4">
                    {cohorts.resources
                      ?.filter((name) =>
                        name?.cohortName
                          ?.toLowerCase()
                          .startsWith(searchValue?.toLowerCase()!!)
                      )
                      .map((cohort, index) => (
                        <div className="mt-4" key={index}>
                          {showCohorts && (
                            <CohortDisplay
                              fetcohortUser={() =>
                                getCohortUsers(cohort.cohortId)
                              }
                              coh={fetchCohorts}
                              onReload={() => {
                                getCohorts();
                              }}
                              cohort={cohort}
                              onClick={() => {
                                handleClick(cohort);
                              }}
                              refreshedCohorts={() => {
                                getCohorts();
                              }}
                            ></CohortDisplay>
                          )}
                        </div>
                      ))}
                  </div>
                )} */}

              {showCohorts && (
                <div className="mb-4 w-full pb-[10%] pl-4">
                  {cohorts?.resources &&
                  cohorts?.resources?.filter((name) =>
                    name?.cohortName
                      ?.toLowerCase()
                      .startsWith(searchValue?.toLowerCase() || "")
                  ).length > 0 ? (
                    cohorts?.resources
                      .filter((name) =>
                        name?.cohortName
                          ?.toLowerCase()
                          .startsWith(searchValue?.toLowerCase() || "")
                      )
                      .map((cohort, index) => (
                        <div className="mt-4" key={index}>
                          {showCohorts && (
                            <CohortDisplay
                              fetcohortUser={() =>
                                getCohortUsers(cohort.cohortId)
                              }
                              coh={fetchCohorts}
                              onReload={() => getCohorts()}
                              cohort={cohort}
                              onClick={() => handleClick(cohort)}
                              refreshedCohorts={() => getCohorts()}
                            />
                          )}
                        </div>
                      ))
                  ) : (
                    <div className="w-full flex justify-center items-center text-lg font-semibold text-mk-primary-bright mt-10">
                      {/* No cohorts present matching search condition */}
                      <FormattedMessage id="users.cohortDisplay.noCohorts"></FormattedMessage>
                    </div>
                  )}
                </div>
              )}
            </div>
            <div>
              {showCohortList && (
                <div className="pb-[10%]">
                  {/* <CohortList
                    currentCohort={currCohort}
                    coh={fetchCohorts}
                    onReload={() => fetchCohorts}
                    cohortListState={setShowCohortList}
                    addNewState={setShowAddNewUser}
                    refreshedCohorts={() => {
                      getCohorts();
                    }}
                  /> */}

                  <CohortListDup
                    currentCohort={currCohort}
                    coh={fetchCohorts}
                    onReload={() => fetchCohorts}
                    cohortListState={setShowCohortList}
                    addNewState={setShowAddNewUser}
                    refreshedCohorts={() => {
                      getCohorts();
                    }}
                  />
                </div>
              )}
            </div>
          </RoundedTab>
          <RoundedTab
            name="user"
            title={intl.formatMessage({
              id: "users.tabName.user",
            })}
          >
            <div className="w-full">
              <div className="mt-4">
                {/* {showSearchUser && (
                    <div className="text-mk-primary-bright text-xl font-semibold">
                      <FormattedMessage id="users.activeUsers" />
                    </div>
                  )} */}
              </div>
              <div className="w-full flex justify-end items-end right-12 top-20">
                <div className="flex justify-end gap-6">
                  {showSearchUser && (
                    <Button
                      className="rounded-lg bg-mk-primary-bright text-white hover:bg-mk-light-grey
                                     hover:text-black focus:outline-none px-4 py-2"
                      onClick={toggleUploadDialog}
                    >
                      <FormattedMessage id="users.uploadUser" />
                    </Button>
                  )}
                  {showSearchUser && (
                    <Button
                      className="rounded-lg bg-mk-primary-bright text-white hover:bg-mk-light-grey
                                      hover:text-black focus:outline-none px-4 py-2"
                      onClick={handleCreateUserClick}
                    >
                      <FormattedMessage id="users.createUser"></FormattedMessage>
                    </Button>
                  )}

                  {uploadDialog && (
                    <Dialog className="requireDialogue">
                      <ComponentDialog
                        component={() => (
                          <UploadFile
                            uploadDialogFunction={setUploadDialog}
                            uploadDialogValue={uploadDialog}
                            triggerFetchAll={setFetchAllUser}
                            triggerFetchBool={fetchAllUser}
                          ></UploadFile>
                        )}
                      />
                    </Dialog>
                  )}
                  {uploadContent && (
                    <Upload
                      multiple={false}
                      defaultFiles={[]}
                      withCredentials={false}
                      saveUrl={
                        "https://demos.telerik.com/kendo-ui/service-v4/upload/save"
                      }
                      removeUrl={
                        "https://demos.telerik.com/kendo-ui/service-v4/upload/remove"
                      }
                      restrictions={{
                        allowedExtensions: [".csv"],
                      }}
                    />
                  )}
                </div>
              </div>

              {showCreateUser && (
                <div className="pb-[10%]">
                  <CreateUser
                    createState={setCreateUser}
                    searchState={setSearchUser}
                    dataGridItems={gridData}
                    formType={formType ? "EDIT" : "NEW"}
                    formTypeFunction={setFormType}
                    refreshDataReference={refreshData}
                    // hasMoreDataReference={hasMoreData}
                    hasMoreData={hasMoreData}
                    hasMoreDataFunction={setHasMoreData}
                    updateDataRef={updateData}
                  />
                </div>
              )}

              <div className="absolute right-12 mt-6"></div>
              {showSearchUser && (
                <div className="pb-[10%]">
                  {/* <SearchUser
        
                      searchUserState={setSearchUser}
                      createUserState={setCreateUser}
                      gridDataExtractFunction={setGridData}
                      dataGridItemFunction={handleGridItemClick}
                      formTypeFunction={setFormType}
                      triggerFetchAll={setFetchAllUser}
                      triggerFetchBool={fetchAllUser}
                    /> */}
                  <div className="text-mk-primary-bright text-2xl font-semibold">
                    <FormattedMessage id="analytics.userView.searchUsers" />
                  </div>
                  <div className="pb-[1%]"></div>
                  <SearchFilterUser
                    userData={userFetchModel}
                    userDataFunction={setUserFetchModel}
                    totalCount={totalUserCount}
                    totalCountFunction={setTotalUserCount}
                    search={searchActive}
                    searchFunction={setSearchActive}
                    formData={formData}
                    formDataFunction={setFormData}
                    selectedLanguage={selectedLanguage}
                    selectedLanguageFunction={setSelectedLanguage}
                    languages={languages}
                    selectedStatus={selectedStatus}
                    selectedStatusFunction={setSelectedStatus}
                    hasMoreData={hasMoreData}
                    hasMoreDataFunction={setHasMoreData}

                    // userStatusFunction={handleStatus}
                  ></SearchFilterUser>

                  <div className="pb-[2%]"></div>

                  <SearchUserDup
                    formTypeFunction={setFormType}
                    searchUserState={setSearchUser}
                    createUserState={setCreateUser}
                    gridDataExtractFunction={setGridData}
                    dataGridItemFunction={handleGridItemClick}
                    userData={userFetchModel}
                    userDataFunction={setUserFetchModel}
                    search={searchActive}
                    searchFunction={setSearchActive}
                    totalCount={totalUserCount}
                    totalCountFunction={setTotalUserCount}
                    formData={formData}
                    formDataFunction={setFormData}
                    refreshDataReference={refreshData}
                    // hasMoreDataReference={hasMoreData}
                    hasMoreData={hasMoreData}
                    hasMoreDataFunction={setHasMoreData}
                    updateDataRef={updateData}
                    selectedLanguage={selectedLanguage}
                    selectedLanguageFunction={setSelectedLanguage}
                    languages={languages}
                    selectedStatus={selectedStatus}
                    selectedStatusFunction={setSelectedStatus}

                    // userStatusFunction={handleStatus}
                  />
                </div>
              )}
              <div className="absolute right-12 mt-6">
                <div className="flex justify-end mt-10 gap-6"></div>
              </div>
            </div>
          </RoundedTab>
        </RoundedTabGroup>
        {/* <div className="pr-[2%]"></div> */}
      </div>
    </div>
  );
}
